<template>
  <v-container
    id="dashboard"
    fluid
    tag="section"
  >
    <v-snackbar xs12
      v-model="snackbar"
      multi-line
      :timeout="timeout"
      top
      color="orange"
    >
      {{ alertmessage }}
      <v-btn
        color="white"
        text
        @click="snackbar = false"
      >
        Close
      </v-btn>
    </v-snackbar>  
 <sequential-entrance fromTop>
  
<v-row>
  <v-col>
    <base-material-card
      color="primary"
      icon="mdi-transfer-right"
      inline
    >
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">
          Send ACH for {{sitedetails.idnum}} 
        </div> 
      </template>
  <v-data-table
    :headers="headers"
    :items="getdepositusers"
    sort-by="username"
    class="elevation-1"
  >
  
    <template v-slot:top>
      <v-toolbar flat color="white">
        <v-toolbar-title>ACH Transactions</v-toolbar-title>

        <v-divider
          class="mx-4"
          inset
          vertical
        ></v-divider>
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="500px">
          <template v-slot:activator="{ on }">
            <v-btn color="warning" dark class="mb-2" to="/Paymentactions">Return</v-btn><v-btn color="primary" dark class="mb-2 mr-4" v-on="on">New ACH Payment</v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field v-model="editedItem.username" label="User Name"></v-text-field>
                  </v-col>                                 
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field v-model="editedItem.email" label="Notification Email Address"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <v-select :items="typeList" v-model="editedItem.usertype" label="Deposit User Type"></v-select>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field v-model="editedItem.accesscode" label="Access Code (1234)"></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
              <v-btn color="blue darken-1" :disabled="!formIsValid" text @click="save">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:item.action="{ item }">
      <v-icon
            
            color="primary"
            size="20"
        @click="editItem(item)"
      >
        mdi-square-edit-outline
      </v-icon>
      <v-icon
            color="black"
            size="20"
            class="ma-4"
        @click="deleteItem(item)"
      >
        mdi-delete
      </v-icon>
    </template>
    <template v-slot:no-data>
      Sorry, No deposit users to display for {{sitedetails.idnum}}
    </template>
  </v-data-table>
    </base-material-card>

    <div class="py-3" />
  </v-col>
</v-row>
   </sequential-entrance>

  </v-container>
</template>

<script>
  const axios = require('axios')
  import moment from 'moment'
  var numeral = require('numeral')

  export default {
    name: 'Depositusersbysite',
    props: ['id'],    
    data: () => ({
      dialog: false,
      sitedetails: '',
      snackbar: false,
      timeout: 5000,
      alertmessage: '',      
      headers: [
        { text: 'User ID', align: 'center', value: 'username' },
        { text: 'User Type', align: 'center', value: 'usertype' },
        { text: 'Access Code', align: 'center', value: 'accesscode' },
        { text: 'Email', align: 'center', value: 'email' },
        { text: 'Actions', align: 'center', value: 'action', sortable: false },
      ],
      alerts: [],
      depositusers: [],
      typeList: ['Standard', 'Cit'],
      editedIndex: -1,
      editedItem: {
        username: '',
        accesscode: '',
        usertype: '',
        email: ''
      },
      defaultItem: {
        username: '',
        accesscode: '',
        usertype: '',
        email: ''
      },
    }),

    computed: {
      formIsValid () {
        return this.editedItem.email !== '' &&
        this.editedItem.accesscode !== '' &&
        this.editedItem.username !== ''
      },    
      formTitle () {
        return this.editedIndex === -1 ? 'New Deposit User' : 'Edit Deposit User'
      },
      getalerts () {
        this.alerts = this.$store.getters.alerts
        return this.alerts
      },
      getdepositusers () {
        this.depositusers = this.$store.getters.depositusers
        return this.depositusers
      }
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
    },

    created () {
      this.id = this.$route.params.id
      this.getsitemap(this.id)
      this.$log.debug('LOADING THIS ID ', this.id)
      this.$store.dispatch("loadDepositusers", this.sitedetails.idnum)
      this.initialize()
    },

    methods: {
      initialize () {
        this.alerts = this.$store.getters.alerts
        this.depositusers = this.$store.getters.depositusers
      },
      getsitemap (machineid) {
        this.$log.debug('sitemap')
        for (let [key, value] of Object.entries(this.$store.getters.loadedSiteProfiles)) {
          // this.$log.debug(`${key}: ${value}`)
          if (value.siteunitsprofile) {
            if (value.siteunitsprofile[0].crypto_idnum===machineid) {
              this.$log.debug(value)
              this.sitedetails = this.$store.getters.loadedSites.find(location => value.idnum === location.idnum)
            }
          }
        }
      },
      editItem (item) {
        this.editedIndex = this.depositusers.indexOf(item)
        this.$log.debug('edited index is ', this.editedIndex, 'edited item was ', item, 'alerts array is ', this.depositusers)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        const index = this.depositusers.indexOf(item)
        this.$log.debug('site info is ', item)
        if (confirm('Are you sure you want to delete this item?') && this.depositusers.splice(index, 1)) {
          this.$log.debug('site info is ', item.key)
          let rec = {
            key: item.key,
            siteid: this.sitedetails.idnum
          }
          this.$store.dispatch('removeDeposituser', rec)
        }
      },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      save () {
        let allowedchars = ""
        allowedchars = this.editedItem.accesscode.match(/^[0-9]*$/gi)
        this.$log.debug('allowedchars ', allowedchars)
        if (!allowedchars) {
          this.alertmessage = 'Only numbers are allowed in PIN numbers'
          this.snackbar = true
          this.close()
          return
        }
        // check for leading zero (pins are ints)
        if (this.editedItem.accesscode[0] === '0') {
          this.$log.debug('no leading zeros allowed ')
          this.alertmessage = 'PINs can not have leading zeros'
          this.snackbar = true
          this.close()
          return
        }
        // check to see if the pin is unique
        let not_allowed_pins = this.depositusers.map(element => element.accesscode)
        this.$log.debug('list of users ', this.depositusers)
        let reserved_pins = ['0000', '9999']

        let PIN_LENGTH = 4
  
        let pin_present = not_allowed_pins.includes(this.editedItem.accesscode)
        if ( pin_present ) {
          this.alertmessage = 'PINs must be unique per safe'
          this.snackbar = true
          this.close()
          return
          // we found their pin already present so say nooooo
        }
        if ( this.editedItem.accesscode.length !== PIN_LENGTH ) {
          this.alertmessage = 'PINs must be 4 digits with no leading zeros, and not be reserved values'
          this.snackbar = true
          this.close()
          return
          // we found their pin already present so say nooooo
        }
        this.$log.debug('EDITED INDEX WAS ', this.editedIndex)
        const user = {
          siteid: this.sitedetails.idnum,
          username: this.editedItem.username.trim(),
          email: this.editedItem.email.trim(),
          usertype: this.editedItem.usertype,
          accesscode: this.editedItem.accesscode.trim(),
          key: this.editedItem.key
        }
        if (this.editedIndex > -1) {
          let userrec = {
            safeid: this.id,
            username: user.username,
            userpin: user.accesscode,
            usertype: user.usertype
          }
          this.$store.dispatch('addsafeusercmd', userrec)
          Object.assign(this.depositusers[this.editedIndex], this.editedItem)
          this.$log.debug('CALLING UPDATE IN VIEW ')
          this.$store.dispatch('updateDeposituser', user)
          this.close()
        } else {
          this.depositusers.push(this.editedItem)
          this.$store.dispatch('createDeposituser', user)
          // we add this to mqtt here also
          let userrec = {
            safeid: this.id,
            username: user.username,
            userpin: user.accesscode,
            usertype: user.usertype
          }
          this.$store.dispatch('addsafeusercmd', userrec)
          this.$store.dispatch("loadDepositusers", this.sitedetails.idnum)
          this.depositusers = this.$store.getters.depositusers
          this.close()
        }
        this.close()
      },
    },
  }
</script>

